require('angular')
require('../auth/auth-module')
require('../../../core/translation/translation-module')
require('../navigation-header/navigation-header-module')
require('../cache/cache-module')
require('../account/account-module')
CommonHeaderDirective = require('./common-header-directive')

modules = [
  'gnp-auth'
  'gnp-navigation-header'
  'gnp-account'
]
angular.module 'gnp-common-header', modules
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .directive('gnpCommonHeader', CommonHeaderDirective)



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-header/common-header-module.coffee